function isMobile() {
    return matchMedia('only screen and (max-width: 767px)').matches;
}

export { isMobile };
